import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// ?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_ask_age_starting_screens~1
			funnel: {
				id: 'ob-ask-age-screen-male',
				locale: ['en'],
			},
		},
		'activity-female-pilates': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_ask_age_starting_screens~1
			funnel: {
				id: 'ob-ask-age-screen-female-pilates',
				locale: ['en'],
			},
		},
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_ask_age_starting_screens~1
			funnel: {
				id: 'ob-ask-age-screen-female-walking',
				locale: ['en'],
			},
		},
		'activity-male-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_ask_age_starting_screens~1
			funnel: {
				id: 'ob-ask-age-screen-male-walking',
				locale: ['en'],
			},
		},
		'activity-female-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-v2&exp=web_ask_age_starting_screens~1
			funnel: {
				id: 'ob-ask-age-screen-female-activity',
				locale: ['en'],
			},
		},
	},
]

export default config
